import { CommonModule } from '@angular/common';
import {
  Directive,
  NgModule,
  OnInit,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AuthFacade } from '@rd/core/auth/store/facades/auth.facade';
import { distinctUntilChanged, filter, tap } from 'rxjs/operators';

@UntilDestroy()
@Directive({
  selector: '[ifLoggedIn]',
})
export class IfLoggedInDirective implements OnInit {
  constructor(
    private auth: AuthFacade,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.auth.isLoggedIn$
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged(),
        tap(() => this.viewContainer.clear()),
        filter((value) => !!value),
      )
      .subscribe(() => {
        this.viewContainer.createEmbeddedView(this.templateRef);
      });
  }
}

@UntilDestroy()
@Directive({
  selector: '[ifNotLoggedIn]',
})
export class IfNotLoggedInDirective implements OnInit {
  constructor(
    private auth: AuthFacade,
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
  ) {}

  ngOnInit(): void {
    this.auth.isLoggedIn$
      .pipe(
        untilDestroyed(this),
        distinctUntilChanged(),
        tap(() => this.viewContainer.clear()),
        filter((value) => !value),
      )
      .subscribe(() => {
        this.viewContainer.createEmbeddedView(this.templateRef);
      });
  }
}

@NgModule({
  declarations: [IfLoggedInDirective, IfNotLoggedInDirective],
  imports: [CommonModule],
  exports: [IfLoggedInDirective, IfNotLoggedInDirective],
})
export class IfLoggedInModule {}
